import surfaceGLSL from "./utils/surface.glsl";

import normalsGLSL from "./utils/normals.glsl";

const fragmentShader = /* glsl */ `
precision highp float;

varying vec3 vNormal;
varying vec2 vUv;
varying vec3 vWorldPosition;


/*
 * Shared shader utilities.
 */
${surfaceGLSL}
${normalsGLSL}


/*
 * Lighting.
 */
uniform vec3 uLightDirection;
uniform vec3 uLightColor;

uniform float uLightIntensity;
uniform float uAmbientIntensity;


/*
 * Toon.
 */
uniform float uBands;


/*
 * ============================================================
 * TOON QUANTIZATION
 * ============================================================
 */

float quantizeLight(
    float value
) {

    float bands =
        max(
            uBands,
            1.0
        );


    if (
        bands <=
        1.0
    ) {

        return 1.0;
    }


    float steps =
        bands -
        1.0;


    return floor(
        value *
        steps +
        0.5
    ) /
    steps;
}


/*
 * ============================================================
 * MAIN
 * ============================================================
 */

void main() {

    vec2 surfaceUv =
        transformSurfaceUv(
            vUv
        );


    vec3 surfaceColor =
        getSurfaceColor(
            surfaceUv
        );


    float ao =
        getAmbientOcclusion(
            surfaceUv
        );


    vec3 emissive =
        getEmissiveColor(
            surfaceUv
        );


    vec3 surfaceNormal =
        getSurfaceNormal(
            surfaceUv
        );


    vec3 lightDirection =
        normalize(
            uLightDirection
        );


    float diffuse =
        max(
            dot(
                surfaceNormal,
                lightDirection
            ),
            0.0
        );


    float ambient =
        uAmbientIntensity *
        ao;


    float illumination =
        clamp(
            ambient +
            diffuse *
            uLightIntensity,
            0.0,
            1.0
        );


    float toonLight =
        quantizeLight(
            illumination
        );


    float quantizedDiffuse =
        max(
            toonLight -
            ambient,
            0.0
        );


    vec3 lighting =
        vec3(
            ambient
        ) +
        (
            uLightColor *
            quantizedDiffuse
        );


    lighting =
        clamp(
            lighting,
            0.0,
            1.0
        );


    vec3 finalColor =
        surfaceColor *
        lighting;


    finalColor +=
        emissive;


    gl_FragColor =
        vec4(
            finalColor,
            1.0
        );
}

`;

export default fragmentShader;
